import { useEffect, useCallback } from 'react';
import { FORM_REQUIREMENTS } from '../../../utilities/constants';
import { useWalletRegistrationFormContext } from '../contexts/wallet-registration-form-context';
import { useWalletRegistrationModalContext } from '../contexts/wallet-registration-modal-context';

/**
 * Custom hook to handle BlackBoxDeviceDetection logic
 * @param {(id: string, value: boolean) => void} updateRequirementStatus
 * @returns {object}
 */
export const useBlackBoxDetection = (updateRequirementStatus) => {
  const { requiredForms } = useWalletRegistrationModalContext();
  const { walletForm } = useWalletRegistrationFormContext();

  // Check if BlackBox is required and not already collected
  const blackBoxRequired = requiredForms.includes(FORM_REQUIREMENTS.IO_BLACK_BOX);
  const blackBoxAlreadyCollected = !!walletForm[FORM_REQUIREMENTS.METADATA]?.[FORM_REQUIREMENTS.IO_BLACK_BOX];

  // Mark BlackBox as complete if it's already collected
  useEffect(() => {
    if (blackBoxRequired && blackBoxAlreadyCollected) {
      updateRequirementStatus(FORM_REQUIREMENTS.IO_BLACK_BOX, true);
    }
  }, [blackBoxRequired, blackBoxAlreadyCollected, updateRequirementStatus]);

  const handleBlackBoxComplete = useCallback(
    (id, value) => {
      updateRequirementStatus(id, value);
    },
    [updateRequirementStatus],
  );

  return {
    blackBoxRequired,
    blackBoxAlreadyCollected,
    handleBlackBoxComplete,
  };
};
